import clsx from 'clsx';
import type { WorkflowStep } from '../shared/WorkflowProgress';
import styles from './QCStepRail.module.css';

export interface QCStepRailStep extends WorkflowStep {
  id: string;
}

export interface QCStepRailProps {
  steps: QCStepRailStep[];
  activeStepId: string;
  onSelectStep: (stepId: string) => void;
}

export function QCStepRail({ steps, activeStepId, onSelectStep }: QCStepRailProps) {
  return (
    <aside className={styles.rail}>
      <h2 className={styles.title}>Quality Check Workflow</h2>
      <ol className={styles.stepList}>
        {steps.map((step, index) => {
          const isActive = step.id === activeStepId;
          const isComplete = step.status === 'complete';
          const severityClass = step.severity
            ? step.severity === 'error'
              ? styles.severityError
              : step.severity === 'warning'
                ? styles.severityWarning
                : styles.severityOk
            : undefined;

          return (
            <li key={step.id} className={styles.stepItem}>
              <button
                type="button"
                className={clsx(styles.stepButton, isActive && styles.active, severityClass)}
                onClick={() => onSelectStep(step.id)}
              >
                <span className={clsx(styles.badge, isComplete && styles.badgeComplete)}>
                  {isComplete ? '✓' : index}
                </span>
                <span className={styles.label}>{step.label}</span>
              </button>
            </li>
          );
        })}
      </ol>
    </aside>
  );
}

export default QCStepRail;
